import { render } from "./Painel.vue?vue&type=template&id=67819f72&scoped=true"
import script from "./Painel.vue?vue&type=script&lang=js"
export * from "./Painel.vue?vue&type=script&lang=js"

import "./Painel.vue?vue&type=style&index=0&id=67819f72&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67819f72"]])

export default __exports__